import * as olSource from 'ol/source'

export default function ESRIWorldImagery() {
  return new olSource.XYZ({
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attributions: [
      '<a  target="_blank" style="color: #2B6CB0;" href="https://huskroua-cbc.eu/">GEOSES</a>, <a  target="_blank" style="color: #2B6CB0;" href="https://www.sgo-penc.hu/index_eng.php">SGO</a>, <a  target="_blank" style="color: #2B6CB0;" href="https://www.bme.hu/?language=en">BME</a>  &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Communit', 
     
    ]
  })
}
